import { render, staticRenderFns } from "./plainLayout.vue?vue&type=template&id=ccae05b6&"
import script from "./plainLayout.vue?vue&type=script&lang=js&"
export * from "./plainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports